// Сервер остаётся источником прав. Эти проверки только скрывают недоступные
// разделы и действия; прямой запрос к API проверяется независимо от меню.
export function can(user, permission) {
  return !!user && (user.admin === true || Array.isArray(user.permissions) && user.permissions.includes(permission))
}

const pages = [
  [/^\/client-users(\/|$)/, 'client_accounts.read'],
  [/^\/(users|access-roles|mobile-app-releases)(\/|$)/, 'admin'],
  [/^\/(unload_vehicles|load_vehicles|vehicles|vehicle_tickets)(\/|$)/, 'vehicles.read'],
  [/^\/inventory-vehicles/, 'vehicles.inventory'],
  [/^\/auto_carriers|^\/shipment_slots/, 'shipments.read'],
  [/^\/auto-trucks/, 'auto_trucks.read'], [/^\/stuffing-orders/, 'stuffing.read'],
  [/^\/cargo-unload/, ['equipments.read', 'fastenings.read']],
  [/^\/(container-tickets|containers)(\/|$)/, 'containers.read'],
  [/^\/(document-trains|trains)(\/|$)/, 'trains.read'],
  [/^\/equipments/, 'equipments.read'], [/^\/fastenings/, 'fastenings.read'],
  [/^\/(car-parks|yard-map)/, 'yard.read'], [/^\/(work_shifts|calendar)/, 'work_shifts.read'],
  [/^\/client-orders/, 'arrivals.read'], [/^\/client-threads/, 'discussions.read'],
  [/^\/bookkeeping/, 'billing.read'], [/^\/(dealers|services|report-services|companies|fastening-models)/, 'dictionaries.read'],
  [/^\/(operations|store_report|table-report-containers)/, 'reports.read'], [/^\/$/, 'reports.read']
]

export function canVisit(user, path) {
  const rule = pages.find(([pattern]) => pattern.test(path))
  if (!rule) return true
  const permission = rule[1]
  if (permission === 'admin') return !!user && user.admin === true
  return (Array.isArray(permission) ? permission : [permission]).some(item => can(user, item))
}
